import { useEffect, useCallback } from 'react';
import { useConsoleStore } from '../store/consoleStore';

interface UseConsoleMessagesOptions {
  clearOnPlay?: boolean;
}

export function useConsoleMessages(options: UseConsoleMessagesOptions = {}) {
  const { clearOnPlay = false } = options;

  const settings = useConsoleStore((state) => state.settings);
  const clear = useConsoleStore((state) => state.clear);
  const addSystemMessage = useConsoleStore((state) => state.addSystemMessage);

  // Listen for play state changes to optionally clear console
  useEffect(() => {
    const handlePlayStateChange = (e: CustomEvent<{ playState: string }>) => {
      if (e.detail.playState === 'playing' && (settings.clearOnPlay || clearOnPlay)) {
        clear();
        addSystemMessage('Console cleared on play');
      }
    };

    window.addEventListener('editor:play-state-change' as never, handlePlayStateChange as EventListener);
    return () => {
      window.removeEventListener('editor:play-state-change' as never, handlePlayStateChange as EventListener);
    };
  }, [settings.clearOnPlay, clearOnPlay, clear, addSystemMessage]);

  // Navigate to code location - dispatches event for script editor to handle
  const navigateToCode = useCallback((fileName: string, lineNumber: number, columnNumber: number) => {
    const event = new CustomEvent('console:navigate-to-code', {
      detail: { fileName, lineNumber, columnNumber },
    });
    window.dispatchEvent(event);
  }, []);

  return {
    navigateToCode,
  };
}
